import { Directive, ElementRef, HostListener, Input } from '@angular/core';
    @Directive({
        selector: '[appInputRestriction]',
        standalone: false
    })
    export class InputRestrictionDirective {
        inputElement: ElementRef;

        @Input({ required: true }) appInputRestriction: 'integer' | 'float';

        constructor(el: ElementRef) {
            this.inputElement = el;
        }

        @HostListener('beforeinput', ['$event'])
        onKeyPress(event: InputEvent) {
            if (this.appInputRestriction === 'integer') {
                if (event.data && !this.isNumber(event)) {
                    event.preventDefault();
                }
            } else if (this.appInputRestriction === 'float') {
                if (event.data && !this.isNumber(event)) {
                    event.preventDefault();

                    if (this.isDotOrCommaAndCanAddDot(event)) {
                        // Manually add a dot to input value
                        this.inputElement.nativeElement.value += ".";

                        // Fire an empty "input" event to trigger angular form change detection
                        this.inputElement.nativeElement.dispatchEvent(new InputEvent("input"));
                    }
                }
            }
        }

        isNumber(event: InputEvent): boolean {
            return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(event.data);
        }

        isDotOrCommaAndCanAddDot(event: InputEvent): boolean {
            const inputValue: string = this.inputElement.nativeElement.value;

            return (event.data == "." || event.data == ",")                     // The character is a dot or a comma
                && inputValue !== "" && !inputValue.includes("."); // The input value is not empty and does not already contain a dot
        }

        @HostListener('paste', ['$event'])
        onPaste(event: ClipboardEvent) {
            event.preventDefault()

            let regex: RegExp;
            if (this.appInputRestriction === 'integer') {
                regex = /^\d+$/g;
            } else if (this.appInputRestriction === 'float') {
                regex = /^\d+(\.\d+)?$/g;
            }

            // Trim the pasted text and replace commas with dots
            const correctedPasteData = event.clipboardData.getData('text/plain')
                .trim()
                .replace(",", ".");

            // Get the value of the input that is not selected
            const inputValue: string = this.inputElement.nativeElement.value;
            const inputValueNotSelectedStart = inputValue.substring(0, this.inputElement.nativeElement.selectionStart);
            const inputValueNotSelectedEnd = inputValue.substring(this.inputElement.nativeElement.selectionEnd, inputValue.length);

            // The input value that we would get by replacing the selected text by the corrected pasted text
            const resultingInputValue = inputValueNotSelectedStart + correctedPasteData + inputValueNotSelectedEnd;

            // The resulting input value is a correct number, set the input value to it
            if (regex.test(resultingInputValue)) {
                this.inputElement.nativeElement.value = resultingInputValue;

                // Fire an empty "input" event to trigger angular form change detection
                this.inputElement.nativeElement.dispatchEvent(new InputEvent("input"));
            }
        }

    }